<!--

	Was macht diese Componente?
	Wofür ist die Compoente da?

	Welche $props gibt es?

	Beispiel Code:
		<RbText
			:text="'my text'"
			:fontSize="'default'"
		></RbText>

	2019-06-08	init

-->

<template>
	<div class="RbText hSpace hSpace--app" :class="elmClasses">
		<div class="RbText__inner richText font font--sans" :class="elmInnerClasses" v-html="text"></div>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import DevInfos from '@/components/DevInfos.vue'
	import { EventBus } from '@/event-bus.js'

	export default {
		name: 'RbText',
		components: {},
		mixins: [],
		props: {
			//imageObject: [Object, Boolean],
			//text: [String],
			text: {
				type     : [String, Boolean],
				default  : false,
				required : false,
			},
			fontSize: {
				type     : [String, Boolean],
				default  : 'default',
				required : false,
			},
		},
		data(){
			return {}
		},
		watch: {
			someVar: {
				handler: function( to, from ) {
				},
				immediate : true,
				deep: true,
			},
		},
		computed: {
			app(){
				return this.$root.$children[0]
			},
			elmClasses(){
				let classes = []

				//classes.push( this.$options.name + '--isAnimating')

				return classes
			},
			elmInnerClasses(){
				let classes = []

				classes.push('font--size' + this._.upperFirst( this.fontSize ))

				return classes
			},
		},
		methods: {
			handleScroll( doLog = true ){
				// groupCollapsed group
				if( doLog ){
					console.groupCollapsed( this.$options.name, '• handleScroll()' )
					//console.log('key:', value)
					console.groupEnd()
				}
			},
		},
		created(){
			//window.addEventListener('scroll', this.handleScroll);
		},
		mounted(){},
		destroyed(){
   			//window.removeEventListener('scroll', this.handleScroll);
 		},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";

	.RbText { // debug

	}
	.RbText { // layout
		.grid;
		.grid--cols-12;
		.grid--colGap;

		&__inner {
			grid-column: 6 / span 7;

			@media @mq[md] {
				grid-column: span 12;
			}
		}
	}
	.RbText { // styling

	}

	@media @mq[xs] {}
	@media @mq[sm] {}
	@media @mq[md] {}
	@media @mq[dt] {}
	@media @mq[lg] {}
	@media @mq[xl] {}
</style>
